export default {
  delete: { method: 'delete', url: 'https://jsonplaceholder.typicode.com/posts/{id}' },
  post: { method: 'post', url: 'https://jsonplaceholder.typicode.com/posts' }
}
